export default __webpack_public_path__ + "static/media/Signup-First-Step.8c3eac54.svg";